// imports (general functionality)
import "./src/third-party/bootstrap/modal"
import "./src/third-party/bootstrap/collapse"
import "./src/third-party/object.assign.pollyfill"
import "./src/third-party/object.getownpropertydescriptors.pollyfill"
import "./src/parallax"
import "./src/modal-draggability"
import "./src/textarea-max-chars"
import "./src/menu-filter-present"
import "./src/tabs"
import "./src/box-zooming"
import "./src/misc"
import "./src/form-validation"

export { Modal } from "./src/modal"
export { rangeMirror } from "./src/range-mirror"
export * from "./src/input-inc-dec"

import VOID from "./src/framework/framework";

import { ajax, drag, pinch, removeFromArray, createAJAXWarningHandler, ajaxValidation, htmlEntities, PHP_serialize } from "./src/utils";
import {VisibleCenterer} from "./src/visible-centering";
VOID.utils.ajax = ajax;
VOID.utils.drag = drag;
VOID.utils.pinch = pinch;
VOID.utils.htmlEntities = htmlEntities;
VOID.utils.removeFromArray = removeFromArray;
VOID.utils.createAJAXWarningHandler = createAJAXWarningHandler;
VOID.utils.ajaxValidation = ajaxValidation;
VOID.utils.PHP_serialize = PHP_serialize;
VOID.utils.VisibleCenterer = VisibleCenterer;

import * as _ from "./src/framework/voidash";
VOID._ = _;

import Shortcuts from "./src/shortcuts";
VOID.Shortcuts = Shortcuts;

import Lang from "./src/localization";
VOID.Lang = Lang;

export { VOID };

import {translateAltString} from "./src/framework/utils";
VOID.utils.translateAltString = translateAltString;

import ClassDelayedToggler from "./src/class-delayed-toggler";
import * as utils from "./src/utils";
VOID.utils.ClassDelayedToggler = ClassDelayedToggler;

// global exports
export {
  addClass,
  removeClass,
  toggleClass,
  toggleClassOnScroll,
  htmlEntities,
  encodeQueryString,
  decodeQueryString,
  alterQueryString,
  requestFullscreen,
  exitFullscreen,
  isFullscreen,
  throttle,
  debounce,
  parseDateString
} from "./src/utils";

export {initTreeView} from "./src/treeview";

export { AJAX } from "./src/ajax";
